
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30427',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30427",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54790",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8099",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11557",
  "I18n": "static-7.1634",
  "quartz": "static-1.7131",
  "quartz-config": "static-1.909",
  "quartz-core": "static-1.6350",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.815",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54777",
  "feedback-utils": "static-1.54781",
  "forms-embed-utils-lib": "static-1.4546",
  "forms-utils-lib": "static-1.12729",
  "foundations-assets": "static-1.4952",
  "foundations-components": "static-1.8085",
  "foundations-theming": "static-1.4513",
  "hub-http": "static-1.6304",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11864",
  "icons": "static-2.651",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3979",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16763",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5405",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57697",
  "transmute": "static-2.85",
  "ui-images": "static-2.1173",
  "UIComponents": "static-3.8503",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3462",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3408",
  "quartz-webpack": "static-1.3355",
  "foundations-theming-specialty": "static-1.2229",
  "property-description-translator": "static-1.3921",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3210",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4407",
  "jasmine-runner": "static-1.6544",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4713",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.806",
  "quartz-head": "static-1.796",
  "quartz-i18n": "static-1.806",
  "quartz-routing": "static-1.561",
  "quartz-test": "static-1.806",
  "quartz-tracking": "static-1.510",
  "trellis-components": "static-1.2160",
  "ui-fonts": "static-1.819",
  "usage-tracker-container": "static-1.7421",
  "usage-tracker-core": "static-1.7281",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7331",
  "reference-resolvers": "static-1.8256",
  "sanitize-text": "static-1.8226",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10445",
  "sanitize": "static-1.4558",
  "outpost": "static-1.4254",
  "rpc-client-utils": "static-1.4736",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4354",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9504",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2141",
  "bend-plugin-foundations-theming": "static-1.2996",
  "foundations-theming-base": "static-1.3498",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.143",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9157",
  "atom": "static-1.5156",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7875",
  "ContentUtils": "static-1.68590",
  "data-token-picker": "static-1.16542",
  "file-manager-components": "static-1.23828",
  "FileManagerCore": "static-1.39327",
  "FileManagerLib": "static-1.39468",
  "frontend-preferences-client": "static-1.8008",
  "hub-http-contrib": "static-1.3123",
  "interframe": "static-3.4841",
  "layout-dnd-components": "static-1.12593",
  "layout-dnd-utils": "static-1.11568",
  "property-translator": "static-1.5477",
  "react-codemirror": "static-1.10709",
  "react-colorpicker": "static-2.10291",
  "reference-resolvers-lite": "static-1.8181",
  "rich-text-lib": "static-1.19961",
  "tinymce-data": "static-1.40668",
  "tinymce-themes": "static-1.56553",
  "ui-addon-emoji-picker": "static-1.9969",
  "ui-addon-sales-email": "static-1.5293",
  "ui-brand-identity-lib": "static-1.15570",
  "bender-build-tools": "static-1.3273",
  "hub-http-shared-msw-handlers": "static-1.10153",
  "hubspotter-http-shared-msw-handlers": "static-1.10151",
  "usage-tracker-session-replay": "static-1.5117",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1019",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.146",
  "chirp-fetch": "static-1.1969",
  "chatspot-core": "static-1.21677",
  "copilot-toolkit": "static-1.11341",
  "customer-data-objects-ui-components": "static-1.13114",
  "data-fetching-client": "static-1.9745",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4842",
  "ui-addon-video-player": "static-1.8786",
  "ui-coaching-tips": "static-1.28781",
  "usage-tracker": "static-1.7431",
  "cms-field-types": "static-1.4894",
  "content-icons-ui": "static-1.2249",
  "integrations-lib": "static-1.16416",
  "customer-data-objects": "static-1.7759",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4734",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4236",
  "ui-addon-iframeable": "static-1.9143",
  "video-components-external": "static-1.11540",
  "video-data-lib": "static-1.35198",
  "audio-components": "static-1.6033",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29441",
  "FileManagerImages": "static-1.36979",
  "foundations-components-legacy": "static-1.1110",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9073",
  "urlinator": "static-1.4618",
  "video-components": "static-1.13542",
  "video-embed": "static-1.36032",
  "ts-schema": "static-1.4142",
  "ContentData": "static-1.68665",
  "layout-data-lib": "static-1.9893",
  "react-dnd-compat": "static-1.4696",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1624",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6971",
  "hs-promise-utils": "static-1.5673",
  "inbound-db-properties-service-client": "static-1.3906",
  "NamespacedHubStyle": "static-2.9120",
  "growth-onboarding-confetti": "static-1.3148",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11233",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.979",
  "magpie-lib": "static-1.5606",
  "magpie-types": "static-1.5066",
  "simple-logging-lib": "static-1.3132",
  "avatar-components": "static-1.2580",
  "customer-data-ui-utilities": "static-1.9907",
  "growth-onboarding-feedback-components": "static-1.6661",
  "flux-actions": "static-1.343",
  "hubspot-apollo-client": "static-1.4959",
  "integrations-error-boundary-lib": "static-1.13831",
  "integrations-tracking-lib": "static-1.5688",
  "laboratory-lib": "static-3.7237",
  "native-integrations-shared-strings": "static-1.7863",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10302",
  "unified-auth": "static-1.587",
  "navigation-messaging": "static-1.7550",
  "content-media-composition-data-lib": "static-1.12585",
  "content-media-compositions": "static-2.16592",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19059",
  "unified-auth-core-lib": "static-1.869",
  "social-insights-client-types": "static-1.22281",
  "advanced-menus-core": "static-1.15253",
  "advanced-menus-lib": "static-1.12178",
  "ExportDialog": "static-6.10464",
  "ui-memberships-settings-lib": "static-1.34260",
  "conditional-properties-service-client": "static-1.3859",
  "crm-pipelines-api-client-types": "static-1.4200",
  "fdsr-migration-layer": "static-1.90",
  "framework-builder-read-service-client": "static-1.4067",
  "framework-data-schema-quick-fetch": "static-1.6876",
  "inbound-db-meta-service-client": "static-1.3648",
  "multi-currency-client-types": "static-1.3753",
  "persist-promise": "static-1.3781",
  "foundations-components-test-utils": "static-1.5568",
  "breeze-engine-core": "static-1.257",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.807",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.418",
  "universal-page-editor-lib": "static-1.3100",
  "ads-unified-auth-lib": "static-1.204",
  "google-sheets-integration-lib": "static-1.468",
  "microsoft-drive-integration-lib": "static-1.607",
  "slack-ui-library": "static-1.10474",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3811",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15252",
  "simple-menus-lib": "static-1.16769",
  "crm-record-cards-service-types": "static-1.3652",
  "location-customization-utils-lib": "static-1.9489",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30427",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54790",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8099",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11557",
  "I18n": "/I18n/static-7.1634",
  "quartz": "/quartz/static-1.7131",
  "quartz-config": "/quartz-config/static-1.909",
  "quartz-core": "/quartz-core/static-1.6350",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.815",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54777",
  "feedback-utils": "/feedback-utils/static-1.54781",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4546",
  "forms-utils-lib": "/forms-utils-lib/static-1.12729",
  "foundations-assets": "/foundations-assets/static-1.4952",
  "foundations-components": "/foundations-components/static-1.8085",
  "foundations-theming": "/foundations-theming/static-1.4513",
  "hub-http": "/hub-http/static-1.6304",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11864",
  "icons": "/icons/static-2.651",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3979",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16763",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5405",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57697",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1173",
  "UIComponents": "/UIComponents/static-3.8503",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3462",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3408",
  "quartz-webpack": "/quartz-webpack/static-1.3355",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2229",
  "property-description-translator": "/property-description-translator/static-1.3921",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3210",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4407",
  "jasmine-runner": "/jasmine-runner/static-1.6544",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4713",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.806",
  "quartz-head": "/quartz-head/static-1.796",
  "quartz-i18n": "/quartz-i18n/static-1.806",
  "quartz-routing": "/quartz-routing/static-1.561",
  "quartz-test": "/quartz-test/static-1.806",
  "quartz-tracking": "/quartz-tracking/static-1.510",
  "trellis-components": "/trellis-components/static-1.2160",
  "ui-fonts": "/ui-fonts/static-1.819",
  "usage-tracker-container": "/usage-tracker-container/static-1.7421",
  "usage-tracker-core": "/usage-tracker-core/static-1.7281",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7331",
  "reference-resolvers": "/reference-resolvers/static-1.8256",
  "sanitize-text": "/sanitize-text/static-1.8226",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10445",
  "sanitize": "/sanitize/static-1.4558",
  "outpost": "/outpost/static-1.4254",
  "rpc-client-utils": "/rpc-client-utils/static-1.4736",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4354",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9504",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2141",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2996",
  "foundations-theming-base": "/foundations-theming-base/static-1.3498",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.143",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9157",
  "atom": "/atom/static-1.5156",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7875",
  "ContentUtils": "/ContentUtils/static-1.68590",
  "data-token-picker": "/data-token-picker/static-1.16542",
  "file-manager-components": "/file-manager-components/static-1.23828",
  "FileManagerCore": "/FileManagerCore/static-1.39327",
  "FileManagerLib": "/FileManagerLib/static-1.39468",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8008",
  "hub-http-contrib": "/hub-http-contrib/static-1.3123",
  "interframe": "/interframe/static-3.4841",
  "layout-dnd-components": "/layout-dnd-components/static-1.12593",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11568",
  "property-translator": "/property-translator/static-1.5477",
  "react-codemirror": "/react-codemirror/static-1.10709",
  "react-colorpicker": "/react-colorpicker/static-2.10291",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8181",
  "rich-text-lib": "/rich-text-lib/static-1.19961",
  "tinymce-data": "/tinymce-data/static-1.40668",
  "tinymce-themes": "/tinymce-themes/static-1.56553",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9969",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5293",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15570",
  "bender-build-tools": "/bender-build-tools/static-1.3273",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10153",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10151",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5117",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1019",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.146",
  "chirp-fetch": "/chirp-fetch/static-1.1969",
  "chatspot-core": "/chatspot-core/static-1.21677",
  "copilot-toolkit": "/copilot-toolkit/static-1.11341",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13114",
  "data-fetching-client": "/data-fetching-client/static-1.9745",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4842",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8786",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28781",
  "usage-tracker": "/usage-tracker/static-1.7431",
  "cms-field-types": "/cms-field-types/static-1.4894",
  "content-icons-ui": "/content-icons-ui/static-1.2249",
  "integrations-lib": "/integrations-lib/static-1.16416",
  "customer-data-objects": "/customer-data-objects/static-1.7759",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4734",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4236",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9143",
  "video-components-external": "/video-components-external/static-1.11540",
  "video-data-lib": "/video-data-lib/static-1.35198",
  "audio-components": "/audio-components/static-1.6033",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29441",
  "FileManagerImages": "/FileManagerImages/static-1.36979",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1110",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9073",
  "urlinator": "/urlinator/static-1.4618",
  "video-components": "/video-components/static-1.13542",
  "video-embed": "/video-embed/static-1.36032",
  "ts-schema": "/ts-schema/static-1.4142",
  "ContentData": "/ContentData/static-1.68665",
  "layout-data-lib": "/layout-data-lib/static-1.9893",
  "react-dnd-compat": "/react-dnd-compat/static-1.4696",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1624",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6971",
  "hs-promise-utils": "/hs-promise-utils/static-1.5673",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3906",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9120",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3148",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11233",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.979",
  "magpie-lib": "/magpie-lib/static-1.5606",
  "magpie-types": "/magpie-types/static-1.5066",
  "simple-logging-lib": "/simple-logging-lib/static-1.3132",
  "avatar-components": "/avatar-components/static-1.2580",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9907",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6661",
  "flux-actions": "/flux-actions/static-1.343",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4959",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13831",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5688",
  "laboratory-lib": "/laboratory-lib/static-3.7237",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7863",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10302",
  "unified-auth": "/unified-auth/static-1.587",
  "navigation-messaging": "/navigation-messaging/static-1.7550",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12585",
  "content-media-compositions": "/content-media-compositions/static-2.16592",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19059",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.869",
  "social-insights-client-types": "/social-insights-client-types/static-1.22281",
  "advanced-menus-core": "/advanced-menus-core/static-1.15253",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12178",
  "ExportDialog": "/ExportDialog/static-6.10464",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34260",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3859",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4200",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.90",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4067",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6876",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3648",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3753",
  "persist-promise": "/persist-promise/static-1.3781",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5568",
  "breeze-engine-core": "/breeze-engine-core/static-1.257",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.807",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.418",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3100",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.204",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.468",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.607",
  "slack-ui-library": "/slack-ui-library/static-1.10474",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3811",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15252",
  "simple-menus-lib": "/simple-menus-lib/static-1.16769",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3652",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9489",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
